var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.42855151,12.2889629 C6.17989881,12.7404026 7.0596333,13 8,13 C10.7614237,13 13,10.7614237 13,8 C13,7.0596333 12.7404026,6.17989881 12.2889629,5.42855151 L5.42855151,12.2889629 Z M3.95266062,10.9364267 L10.9364267,3.95266062 C10.111922,3.35343147 9.09723516,3 8,3 C5.23857625,3 3,5.23857625 3,8 C3,9.09723516 3.35343147,10.111922 3.95266062,10.9364267 Z M8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.3c5b46c4dc7c87a770abf0ef53595eb6.svg";
export { ForwardRef as ReactComponent };